import { render, staticRenderFns } from "./OwnerBasicForm.vue?vue&type=template&id=0ea7430c&scoped=true&"
import script from "./OwnerBasicForm.vue?vue&type=script&lang=js&"
export * from "./OwnerBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7430c",
  null
  
)

export default component.exports